//All date and time methods should be moved here for organization purposes
import dayjs from "dayjs";
import customParseFormat from "dayjs/plugin/customParseFormat";

dayjs.extend(customParseFormat);

function date(date_string) {
  return dayjs(getDateObject(date_string));
}

const today = dayjs();

function getDateObject(dateString) {
  const formatString = "DD/MM/YYYY, HH:mm:ss";
  return dayjs(dateString, formatString).toDate();
}

/**
 * - Handles Strings (DD/MM/YYYY) and Dayjs objects (from MUI DatePickers)
 * - Returns a string "DD/MM/YYYY" or null.
 */
function formatToSimpleDate(dateValue) {
  if (!dateValue) return null;

  const d =
    typeof dateValue === "string"
      ? dayjs(dateValue, "DD/MM/YYYY")
      : dayjs(dateValue);

  return d.isValid() ? d.format("DD/MM/YYYY") : null;
}

/**
 * - Takes a list of date strings (parsed with the given format, ISO when omitted)
 * - Returns the earliest valid date as a Dayjs object, or undefined if there is none.
 *   Meant for a calendar's `referenceDate`, so it opens on the month the dates start in.
 */
function getEarliestDate(dates = [], format = undefined) {
  const valid = (dates || [])
    .map((value) => dayjs(value, format))
    .filter((d) => d.isValid());

  if (valid.length === 0) return undefined;

  return valid.reduce((earliest, d) => (d.isBefore(earliest) ? d : earliest));
}

export { getDateObject, formatToSimpleDate, date, today, getEarliestDate };
